var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisualizeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "m12 7v-6.54c.913.346 1.753.879 2.465 1.59l3.484 3.486c.712.711 1.245 1.551 1.591 2.464h-6.54c-.552 0-1-.449-1-1zm7.5 11c3.044 0 4.279-.811 4.5-1.079v-2.421c0-.883-1.85-1.5-4.5-1.5s-4.5.617-4.5 1.5v2.421c.221.268 1.456 1.079 4.5 1.079m0 6c2.859 0 4.5-.79 4.5-2.167v-2.61c-1.079.466-2.57.777-4.5.777s-3.421-.311-4.5-.777v2.61c0 1.377 1.641 2.167 4.5 2.167m-6.5-2.167v-7.333c0-1.052.634-3.5 6.5-3.5.175 0 .33.009.496.013-.005-.401-.012-.911-.019-1.013h-6.976c-1.654 0-3-1.346-3-3v-6.976c-.161-.011-.322-.024-.485-.024h-4.516c-2.757 0-5 2.243-5 5v14c0 2.757 2.243 5 5 5h8.751c-.651-.842-.751-1.727-.751-2.167zm-7-2.833c0 .552-.447 1-1 1s-1-.448-1-1v-3c0-.552.447-1 1-1s1 .448 1 1zm4 0c0 .552-.447 1-1 1s-1-.448-1-1v-7c0-.552.447-1 1-1s1 .448 1 1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualizeWhite);
export default __webpack_public_path__ + "static/media/visualize_white.27d5f6352b74963396313c6049e73879.svg";
export { ForwardRef as ReactComponent };